import { render, staticRenderFns } from "./Assetable.vue?vue&type=template&id=8a8b2168"
import script from "./Assetable.vue?vue&type=script&lang=js"
export * from "./Assetable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports